import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[appOptionTemplate]',
    standalone: false
})
export class OptionTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}
